import { useEffect, useState } from "react";
import "./Style.css";

const TabsContainer = ({
  tabs,
  defaultTab,
  activeTab: controlledActiveTab,
  onActiveTabClick,
  processingMessage,
}) => {
  const [activeTab, setActiveTab] = useState(controlledActiveTab ?? defaultTab);

  useEffect(() => {
    if (
      controlledActiveTab &&
      controlledActiveTab !== "" &&
      controlledActiveTab !== activeTab
    ) {
      setActiveTab(controlledActiveTab);
    }
  }, [controlledActiveTab, activeTab]);

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    onActiveTabClick?.(tabKey);
  };

  return (
    <div className="tabs-container">
      <div className="tabs-navigation-wrapper">
        <nav className="tabs-navigation">
          {tabs?.length > 0 &&
            tabs?.map(({ key, label, icon: Icon }) => (
              <button
                key={key}
                onClick={() => handleTabClick(key)}
                className={`tabs-button ${
                  activeTab === key
                    ? "tabs-button-active"
                    : "tabs-button-inactive"
                }`}
              >
                {Icon && <Icon />}
                <span>{label}</span>
              </button>
            ))}
        </nav>
      </div>

      {processingMessage && (
        <div className="px-6 py-4 bg-blue-50 border-b border-blue-200">
          <p className="text-blue-800 text-sm font-medium">
            {processingMessage}
          </p>
        </div>
      )}
      <div className="tabs-content">
        {tabs.find((t) => t.key === activeTab)?.content}
      </div>
    </div>
  );
};

export default TabsContainer;
